import { checkExpiry, dateExpiry } from 'helpers/date';
import { pluralise } from 'utils/string';
import {
  Highlight,
  Wrapper,
  StyledBox,
  StyledPaper,
  SurprisePerkImage,
  VisitText,
  SmallArrowLeft,
  SmallArrowRight,
  ArrowLeft,
  ArrowRight,
} from './ExpiryCard.styles';

export interface ExpiryCardProps {
  cycleVisits: number;
  expiry?: string | undefined;
}

function ExpiryCard({ cycleVisits, expiry }: ExpiryCardProps) {
  const visitsLeft = 4 - cycleVisits;
  const text = visitsLeft === 4 ? 'within' : 'before';
  const visits = pluralise('time', visitsLeft);
  const date = visitsLeft === 4 ? '1 year' : dateExpiry(expiry);
  const expiryDate = checkExpiry(expiry).toString();

  return (
    <Wrapper>
      <StyledPaper>
        <VisitText variant="body1" aria-label="Visit Expiry Text">
          Visit <Highlight expiry={expiryDate}>{visitsLeft}</Highlight> {visits} {text}{' '}
          <Highlight expiry={expiryDate}>{date}</Highlight>
        </VisitText>
      </StyledPaper>

      <StyledBox>
        <SmallArrowLeft />
        <ArrowLeft />
        <SurprisePerkImage />
        <SmallArrowRight />
        <ArrowRight />
      </StyledBox>
    </Wrapper>
  );
}

export default ExpiryCard;
